import { useEffect, useState } from 'react';
import sortBy from 'lodash.sortby';
import uniq from 'lodash.uniq';
import useSavedContacts from '@hooks/useSavedContacts';
import useViewerEvents from '@hooks/useViewerEvents';

const useEventsRecommended = () => {
    const [recommendedEvents, setRecommendedEvents] = useState(null);
    const { data: contactData } = useSavedContacts({ fields: 'events { recordId code }' });
    const { data: viewerEvents } = useViewerEvents();

    useEffect(() => {
        if (!contactData || !viewerEvents) {
            return;
        }

        const allEvents = contactData.contacts.reduce((combinedEvents, contact) => {
            const contactEventCodes = contact.events
                .filter(event => !!event)
                .filter(event => !viewerEvents.map(viewerEvent => viewerEvent.code).includes(event.code))
                .map(({ code }) => code);
            return [...combinedEvents, ...contactEventCodes];
        }, []);

        setRecommendedEvents(uniq(sortBy(allEvents)));
    }, [contactData, viewerEvents]);

    return { recommendedEvents };
};

export default useEventsRecommended;
